import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { getInvestorData } from '@dealstack/frontend/shared/dataExchange/services/shareholder/investment.service';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import {
	DataShareholderInvestorTct,
	DataShareholderInvestorWithPersonRes,
} from '@dealstack/shared/lib/generated';

type Options = Omit<
	UseQueryOptions<
		ApiV1.Response<DataShareholderInvestorTct>,
		unknown,
		DataShareholderInvestorTct,
		[string]
	>,
	'queryKey' | 'queryFn' | 'select'
>;

export const useInvestor = (
	options?: Options
): UseQueryResult<DataShareholderInvestorWithPersonRes | undefined, unknown> => {
	const { ...queryOptions } = options || {};

	return useQuery({
		queryKey: [API_PATHS.SHAREHOLDER_INVESTOR_GET],
		queryFn: () => getInvestorData(),
		select: (data: ApiV1.Response<DataShareholderInvestorWithPersonRes>) => data.payload,
		...queryOptions,
	});
};
